import styled from '@emotion/styled';
import { colors } from 'inpock-ui-react/dist/src/color';

export const OrderGroupContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const OrderGroupHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  .date-container {
    display: flex;
    align-items: center;
    gap: 6px;

    .vertical-divider {
      width: 1px;
      height: 14px;
      background-color: ${colors.gray200};
    }
  }

  .detail-btn {
    display: flex;
    align-items: center;
    cursor: pointer;
  }
`;

export const OrderGroupBody = styled.div`
  display: flex;
  gap: 10px;

  .order-group-image {
    position: relative;

    .image-count {
      position: absolute;
      display: flex;
      align-items: center;
      justify-content: center;
      right: 1px;
      bottom: 4px;
      background-color: rgba(0, 0, 0, 0.6);
      border-top-left-radius: 4px;
      border-bottom-right-radius: 4px;
      min-width: 17px;
    }
  }

  .order-group-info {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 5px;

    .order-group-name {
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
    }

    .order-group-count {
      white-space: nowrap;
      overflow: hidden;
    }
  }
`;

export const StatusBadge = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 6px;
  background-color: ${colors.orange100};
  padding: 0 6px;
  height: 24px;
  width: fit-content;
`;

export const OrderGroupContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const BannerWrapper = styled.div`
  padding: 0 12px 20px;
`;
